import { Row } from '@tanstack/react-table';

interface GetRowShadowOptionsProps {
  isFirstSubRow: boolean;
  isLastSubRow: boolean;
}

const getRowShadowOptions = ({
  isFirstSubRow,
  isLastSubRow,
}: GetRowShadowOptionsProps): string | undefined => {
  if (isFirstSubRow && isLastSubRow)
    return 'shadow-[inset_0_1px_0_#64748B,inset_0_-1px_0_#64748B]';
  if (isFirstSubRow) return 'shadow-[inset_0_1px_0_#64748B]';
  if (isLastSubRow) return 'shadow-[inset_0_-1px_0_#64748B]';

  return undefined;
};

interface RowStylingOptions<T> {
  row: Row<T>;
  index: number;
  rows: Row<T>[];
}

export const getRowStyling = <T>({
  row,
  index,
  rows,
}: RowStylingOptions<T>): string | undefined => {
  const isSubRow = row.depth > 0;
  if (!isSubRow) return undefined;

  const previousRow = rows[index - 1];
  const nextRow = rows[index + 1];

  const isFirstSubRow = index === 0 || previousRow.depth < row.depth;
  const isLastSubRow = index === rows.length - 1 || nextRow.depth < row.depth;

  return getRowShadowOptions({ isFirstSubRow, isLastSubRow });
};

export const DEFAULT_MIN_PAGE = 1;

export const isRowWithId = <T>(obj: T): obj is { id: string } & T =>
  typeof obj === 'object' && obj && 'id' in obj && typeof obj.id === 'string';

export const getRowId = <T>(row: T, index?: number) => {
  const isRowObject = typeof row === 'object' && row;
  const id = isRowObject && 'id' in row ? row.id : index;

  const name =
    isRowObject && 'name' in row ? String((row as { name: string }).name) : '';
  const nameHash = name ? `-${name.replace(/[^a-zA-Z0-9]/g, '_')}` : '';

  return `${String(id)}${nameHash}`;
};
